module.exports = __webpack_public_path__ + "static/media/spotifybannertablet.32f393d8.png";